"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Workstream = void 0;
var create_entity_1 = require("../../utils/create-entity");
var gql = String.raw;
var workstream_card_1 = require("../../components/entities/workstream-card");
var workstream_details_banner_1 = require("../../components/entities/workstream-details-banner");
var graphql_1 = require("../../utils/graphql");
exports.Workstream = {
  name: 'Workstream',
  label: 'Activity',
  pluralLabel: 'Activities',
  slug: 'activity',
  pluralSlug: 'activities',
  usePublishStatus: true,
  usePermissions: true,
  useConversation: true,
  useFollowers: true,
  useModerators: true,
  useSlices: true,
  components: {
    card: workstream_card_1.WorkstreamCard,
    adminCard: workstream_card_1.WorkstreamCard,
    banner: workstream_details_banner_1.WorkstreamDetailsBanner
  },
  table: {
    fieldNames: ["name", "type", "description", "status"]
  },
  autoRoutes: ['create', 'update', 'list', 'details'],
  grid: {
    columns: 1
  },
  list: {
    pad: true,
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      type { id name slug }\n      tasks { id name slug  due completed description { id text html } }\n      status { id name slug }\n      team { id name slug description { id text } }\n      description { id text html }\n      links { id name slug url types { id name slug } type { id name slug } image { id url } }\n      files { ...FileAssetValueFields }\n      documents { id name slug type { id name slug } }\n    "], ["\n      type { id name slug }\n      tasks { id name slug  due completed description { id text html } }\n      status { id name slug }\n      team { id name slug description { id text } }\n      description { id text html }\n      links { id name slug url types { id name slug } type { id name slug } image { id url } }\n      files { ...FileAssetValueFields }\n      documents { id name slug type { id name slug } }\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      status { id name slug }\n      team { id name slug members { id slug name person { id name slug photo { id url thumbnails { id full { id url width height } } } } } }\n      type { id name slug }\n      due\n      tasks { id name slug due completed description { id text } }\n      files {\n        id name slug\n        createdBy { ...CreatorFields }\n        openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n        thumbnail { id url thumbnails { id full { id url width height } } }\n        file { ...FileAssetValueFields }\n      }\n      links {\n        id\n        name\n        url\n        description { id text html }\n      }\n      documents {\n        id\n        name\n        slug\n        createdBy { ...CreatorFields }\n        type {\n          id\n          name\n          slug\n        }\n        descriptionOrContent {\n          text(truncate: { words: 30 })\n        }\n      }\n    "], ["\n      status { id name slug }\n      team { id name slug members { id slug name person { id name slug photo { id url thumbnails { id full { id url width height } } } } } }\n      type { id name slug }\n      due\n      tasks { id name slug due completed description { id text } }\n      files {\n        id name slug\n        createdBy { ...CreatorFields }\n        openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url } }\n        thumbnail { id url thumbnails { id full { id url width height } } }\n        file { ...FileAssetValueFields }\n      }\n      links {\n        id\n        name\n        url\n        description { id text html }\n      }\n      documents {\n        id\n        name\n        slug\n        createdBy { ...CreatorFields }\n        type {\n          id\n          name\n          slug\n        }\n        descriptionOrContent {\n          text(truncate: { words: 30 })\n        }\n      }\n    "])))
  },
  filters: {
    fields: {
      type: {
        entityTypeName: 'WorkstreamType'
      },
      status: {
        entityTypeName: 'ProjectStatus'
      }
    }
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'tasks'
    }, {
      name: 'documents'
    }, {
      name: 'files'
    }, {
      name: 'links'
    }, {
      name: 'properties'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'description'
      },
      tasks: {
        type: 'linkedTable',
        fieldSet: 'tasks',
        entityTypeName: 'Task'
      },
      type: {
        type: 'linked',
        entityTypeName: 'WorkstreamType',
        description: 'What type of {{WORKSTREAM}} is this?'
      },
      status: {
        type: 'linked',
        entityTypeName: 'ProjectStatus',
        description: 'How far along is this {{WORKSTREAM}}?'
      },
      due: {
        type: 'date',
        description: 'Does this {{Task.label}} have a due date?'
      },
      documents: {
        type: 'linkedMultiple',
        fieldSet: 'documents',
        entityTypeName: 'Document'
      },
      files: {
        type: 'linkedMultiple',
        fieldSet: 'files',
        entityTypeName: 'FileAsset'
      },
      links: {
        type: 'linkedMultiple',
        fieldSet: 'links',
        entityTypeName: 'Link'
      }
    })
  }
};
var templateObject_1, templateObject_2;